import moment from "moment";

const escapeICSText = (text = "") => text.replace(/([,;])/g, "\\$1").replace(/\n/g, "\\n");

const buildAlarm = (trigger, description) =>
  ["BEGIN:VALARM", `TRIGGER:${trigger}`, "ACTION:DISPLAY", `DESCRIPTION:${description}`, "END:VALARM"];

const isAppleDevice = () =>
  /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent) && !window.MSStream;

const downloadICSEvent = ({ title, description, location, date, time = "20:00" }) => {
  const start = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm");
  const end = start.clone().add(3, "hour");
  const uid = `${Date.now()}@slickracing.com.ua`;

  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//SlickRacing//Schedule//UA",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${moment().utc().format("YYYYMMDDTHHmmss[Z]")}`,
    `DTSTART:${start.utc().format("YYYYMMDDTHHmmss[Z]")}`,
    `DTEND:${end.utc().format("YYYYMMDDTHHmmss[Z]")}`,
    `SUMMARY:${escapeICSText("Slick Racing: " + (title || "Event"))}`,
    description && `DESCRIPTION:${escapeICSText(description)}`,
    location && `LOCATION:${escapeICSText(location)}`,
    ...buildAlarm("-P2D", "Race in 2 days"),
    ...buildAlarm("-PT10H", "Race in 10 hours"),
    ...buildAlarm("-PT1H", "Race in 1 hour"),
    "END:VEVENT",
    "END:VCALENDAR",
  ].filter(Boolean);

  const blob = new Blob([lines.join("\r\n")], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${title || "event"}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const openGoogleCalendarEvent = ({ title, description, location, date, time = "20:00" }) => {
  const start = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm");
  const end = start.clone().add(3, "hour");

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `Slick Racing Ukraine: ${title || "Event"}`,
    dates: `${start.utc().format("YYYYMMDDTHHmmss[Z]")}/${end.utc().format("YYYYMMDDTHHmmss[Z]")}`,
    details: description || "",
    location: location || "",
  });

  window.open(`https://calendar.google.com/calendar/render?${params.toString()}`, "_blank");
};

export const addToCalendar = (eventData) => {
  if (isAppleDevice()) {
    downloadICSEvent(eventData);
  } else {
    openGoogleCalendarEvent(eventData);
  }
};
